import React from 'react';
import X from '../../assets/icons/new_icon/x.svg';
interface UbbeModalHeaderProps {
  headerText: string;
  className?: string;
  onClose: any;
}
const UbbeModalHeader = ({
  headerText,
  className,
  onClose,
}: UbbeModalHeaderProps) => {
  return (
    <div
      className={`d-flex w-100 justify-content-between px-3 py-3 border-bottom align-items-center ${className}`}
    >
      <h3 className='newubbemodalheading mb_0'>{headerText}</h3>

      <img
        alt='close'
        src={X}
        onClick={onClose}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
};

export default UbbeModalHeader;
